var _style, _defs, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledDeviceAppleWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{mask:url(#mask0_1140_1581_00000031897404749634651180000010039412498437473212_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#939393;}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 10,
    y: 4,
    width: 13.8,
    height: 24
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 4,
    width: 13.8,
    height: 24,
    id: "mask0_1140_1581_00000031897404749634651180000010039412498437473212_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.5,5.6c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4C19.7,4,19.5,4,18.9,4h-4.8c-0.6,0-0.8,0-1.1,0.1 c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.6c0,0.8-0.3,1.1-0.7,1.7C11.7,8,11.7,8,11.6,8.1C11.2,8.7,11,9,10.8,9.3 c-0.1,0.1-0.2,0.2-0.3,0.3c0,0-0.1,0.1-0.1,0.1l0,0.1l0,0C10.1,10.1,10,10.5,10,11v10c0,0.5,0.1,0.9,0.4,1.3l0,0c0,0,0,0,0,0.1 c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.3l0,0c0.2,0.3,0.5,0.6,0.9,1.1c0.1,0.1,0.1,0.2,0.2,0.2l0,0c0.4,0.6,0.7,0.9,0.7,1.7 v0.6c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h4.8c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4 c0.1-0.2,0.1-0.5,0.1-1.1v-0.6c0-0.8,0.3-1.1,0.7-1.7c0.1-0.1,0.1-0.2,0.2-0.2c0.4-0.5,0.6-0.9,0.9-1.1l0,0 c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0-0.1l0,0c0.2-0.4,0.4-0.8,0.4-1.3v-5.8c0.4,0,0.8-0.3,0.8-0.8V13 c0-0.4-0.3-0.8-0.8-0.8V11c0-0.5-0.1-0.9-0.4-1.3l0,0l0-0.1c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.3v0 C22,9,21.8,8.7,21.4,8.1C21.3,8,21.3,8,21.2,7.9c-0.4-0.6-0.7-0.9-0.7-1.7V5.6z M12.2,9.8h8.5c0.7,0,1.2,0.6,1.2,1.2v10 c0,0.7-0.6,1.2-1.2,1.2h-8.5c-0.7,0-1.2-0.6-1.2-1.2V11C11,10.3,11.6,9.8,12.2,9.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledDeviceAppleWatch);
export default __webpack_public_path__ + "static/media/disabled-device-apple-watch.d886fed3c2149b25762eb889761b2491.svg";
export { ForwardRef as ReactComponent };